import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76564011"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "mediacalBox" }
const _hoisted_4 = { class: "mediacalBack" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"mediaclText\" data-v-76564011><div class=\"left\" data-v-76564011><div class=\"sex\" data-v-76564011>线索2：查体</div><div class=\"age\" data-v-76564011>女，17岁</div></div></div><div class=\"bottom\" data-v-76564011></div>", 2)
const _hoisted_7 = { class: "boxTail" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "leftright" }, null, -1))
const _hoisted_9 = { class: "textBox" }
const _hoisted_10 = { class: "innerText" }
const _hoisted_11 = { class: "leftBox" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rightBox" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "desttext" }, [
    /*#__PURE__*/_createElementVNode("span", null, "体格检查："),
    /*#__PURE__*/_createTextVNode("体温:36.5℃:心率:83次/1分:呼吸:21次/分:血压:116/81mmHg。神清,轻 度张口呼吸状态，上列牙齿排列略欠整齐。余未 肿伴清涕，双窦口复合体通畅，鼻咽部鼻涕倒 见明显异常 ")
  ])
], -1))
const _hoisted_13 = { class: "innerText" }
const _hoisted_14 = { class: "leftBox" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rightBox" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "desttext" }, [
    /*#__PURE__*/_createElementVNode("span", null, "专科检查"),
    /*#__PURE__*/_createTextVNode(" 双侧鼻腔黏膜苍白，伴较多清涕， 下鼻甲水肿明显，大部鼻腔被堵塞，鼻腔后段 无法窥及。耳、咽部未见明显异常。 ")
  ])
], -1))
const _hoisted_16 = { class: "innerText" }
const _hoisted_17 = { class: "leftBox" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rightBox" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "desttext" }, [
    /*#__PURE__*/_createElementVNode("span", null, "实验室检查"),
    /*#__PURE__*/_createTextVNode(" 血清特异性lgE检测:"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("血清lgE(+)；尘螨(+) ")
  ])
], -1))
const _hoisted_19 = { class: "btnBox" }
const _hoisted_20 = { class: "ip" }
const _hoisted_21 = {
  style: {"width":"4rem","margin":"0 auto"},
  class: "home"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_question = _resolveComponent("question")!
  const _component_question2 = _resolveComponent("question2")!
  const _component_question4 = _resolveComponent("question4")!
  const _component_correct = _resolveComponent("correct")!
  const _component_correct4 = _resolveComponent("correct4")!
  const _component_reason = _resolveComponent("reason")!
  const _component_jiexiao = _resolveComponent("jiexiao")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_image, {
          src: require('../assets/logo.png')
        }, null, 8, ["src"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_van_image, {
                    class: "rightImg",
                    width: ".64rem",
                    height: ".6133rem",
                    src: require('../assets/duigou.png')
                  }, null, 8, ["src"])
                ]),
                _hoisted_12
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_van_image, {
                    class: "rightImg",
                    width: ".64rem",
                    height: ".6133rem",
                    src: require('../assets/duigou.png')
                  }, null, 8, ["src"])
                ]),
                _hoisted_15
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_van_image, {
                    class: "rightImg",
                    width: ".64rem",
                    height: ".6133rem",
                    src: require('../assets/duigou.png')
                  }, null, 8, ["src"])
                ]),
                _hoisted_18
              ])
            ])
          ])
        ])
      ], 512), [
        [_vShow, $data.chatiShow]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_van_image, {
            onClick: $options.showPopup,
            width: "5.64rem",
            height: "1.3333rem",
            src: require('../assets/jxbtn.png')
          }, null, 8, ["onClick", "src"]),
          _createVNode(_component_van_image, {
            class: "finger",
            width: "1.28rem",
            height: "1.28rem",
            src: require('../assets/dong.gif')
          }, null, 8, ["src"])
        ])
      ], 512), [
        [_vShow, $data.chatiShow]
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_van_popup, {
          show: $data.show,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($data.show) = $event)),
          "close-on-click-overlay": false
        }, {
          default: _withCtx(() => [
            ($data.flag == 'question')
              ? (_openBlock(), _createBlock(_component_question, {
                  key: 0,
                  onOnChanged: $options.updateChanged,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'question2')
              ? (_openBlock(), _createBlock(_component_question2, {
                  key: 1,
                  onOnChanged: $options.updateChanged,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'question4')
              ? (_openBlock(), _createBlock(_component_question4, {
                  key: 2,
                  onOnChanged: $options.updateChanged,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'correct')
              ? (_openBlock(), _createBlock(_component_correct, {
                  key: 3,
                  onOnChanged: $options.updateCorrect,
                  postaimqus: $data.postaimqus,
                  correct: $data.correct
                }, null, 8, ["onOnChanged", "postaimqus", "correct"]))
              : _createCommentVNode("", true),
            ($data.flag == 'correct4')
              ? (_openBlock(), _createBlock(_component_correct4, {
                  key: 4,
                  onOnChanged: $options.updateCorrect,
                  postaimqus: $data.postaimqus,
                  correct: $data.correct
                }, null, 8, ["onOnChanged", "postaimqus", "correct"]))
              : _createCommentVNode("", true),
            ($data.flag == 'reason')
              ? (_openBlock(), _createBlock(_component_reason, {
                  key: 5,
                  onOnChanged: $options.reasonCorrect,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'jiexiao')
              ? (_openBlock(), _createBlock(_component_jiexiao, {
                  key: 6,
                  onOnChanged: $options.jiexiaoChanged,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ]),
    _createVNode(_component_toNav, { menu: $data.aimNum }, null, 8, ["menu"])
  ], 64))
}